import { ChevronRightIcon } from "lucide-react";
import { useState } from "react";

/** Collapsed one-liner that expands to pretty-printed JSON (meta / props columns). */
export function JsonView({ value, label = "JSON" }: { value: unknown; label?: string }) {
  const [open, setOpen] = useState(false);
  if (value === null || value === undefined)
    return <span className="text-muted-foreground">—</span>;
  const compact = JSON.stringify(value);
  const empty = compact === "{}" || compact === "[]";
  if (empty) return <span className="text-muted-foreground">—</span>;
  return (
    <div className="max-w-md">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="inline-flex max-w-full items-center gap-1 font-mono text-xs hover:text-foreground"
        aria-expanded={open}
      >
        <ChevronRightIcon
          className={`size-3 shrink-0 transition-transform ${open ? "rotate-90" : ""}`}
        />
        <span className="truncate">{open ? label : compact}</span>
      </button>
      {open ? (
        <pre className="mt-1 max-h-64 overflow-auto rounded-md border bg-muted p-2 font-mono text-[11px] leading-snug">
          {JSON.stringify(value, null, 2)}
        </pre>
      ) : null}
    </div>
  );
}
